import {
  START_POST_FORM_ROUTINE,
  CLOSE_POST_FORM,
  UPDATE_POST_FORM_FIELD,
  SAVE_POST_FORM_ROUTINE,
  SELECT_POST_FORM_PLATFORM,
  TOGGLE_POST_FORM_PLATFORM_LINK,
  CHECK_INSTAGRAM_POST_OVERLAPPING,
} from "constants/ActionTypes";
import { createAction } from "@reduxjs/toolkit";
import { AccountPlatformType, AccountType } from "../shared/types/accounts";
import type { FormPlatformType } from "../shared/types/post";
import { Post } from "../features/post";
import { StartPostFormSuccessPayload } from "../reducers/types";

// Post - FORM (edit / create)
export const startPostForm = createAction(
  START_POST_FORM_ROUTINE.TRIGGER,
  function prepare(post: Post, accounts: AccountType[]) {
    return {
      payload: {
        post,
        accounts,
      } satisfies StartPostFormSuccessPayload,
    };
  }
);

export const closePostForm = createAction(
  CLOSE_POST_FORM,
  function prepare(postId: string) {
    return {
      payload: {
        postId,
      },
    };
  }
);

export const savePostForm = createAction(
  SAVE_POST_FORM_ROUTINE.TRIGGER,
  function prepare(form) {
    return {
      payload: {
        form,
      },
    };
  }
);

export const updatePostFormField = createAction(
  UPDATE_POST_FORM_FIELD,
  function prepare(
    postId: string,
    values: Record<string, unknown>,
    targetPlatform?: FormPlatformType
  ) {
    return {
      payload: { postId, values, targetPlatform },
    };
  }
);

export const selectPlatform = createAction(
  SELECT_POST_FORM_PLATFORM,
  function prepare(
    platformType: AccountPlatformType,
    postId: string | undefined
  ) {
    return {
      payload: {
        platformType,
        postId,
      },
    };
  }
);

export const checkInstagramPostOverlapping = createAction(
  CHECK_INSTAGRAM_POST_OVERLAPPING.TRIGGER,
  function prepare({ postId, accounts, isNow, when, done }) {
    return {
      payload: {
        postId,
        accounts,
        isNow,
        when,
        done,
      },
    };
  }
);

export const togglePlatformLink = createAction(
  TOGGLE_POST_FORM_PLATFORM_LINK,
  function prepare(postId?: string) {
    return {
      payload: { postId },
    };
  }
);
